import { InjectionToken } from '@angular/core';

// TODO ppt: add values and documentation.
export interface ReportExportConfigurations {
  baseUrl: string;
  s3BucketImagesUrl: string;
  edpMultimediaURI: string;
}

export interface UserInfoResolver {
  getUserLocationPerms(): any;
}

export const REPORT_EXPORT_CONFIGS_TOKEN = new InjectionToken<ReportExportConfigurations>(
  'REPORT_EXPORT_CONFIGS_TOKEN'
);
export const INFO_USER_RESOLVER_TOKEN = new InjectionToken<UserInfoResolver>('INFO_USER_RESOLVER_TOKEN');
